import { useTheme } from "@mui/material";
import { FileText, Shield, SquareCheckBig } from "lucide-react";
import { NotificationTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { MyplannActivityIcon } from "web_myplann/Shared/Icons";

export const NotificationType = {
	activity: "activity",
	task: "task",
	meetingRecord: "meetingRecord",
	investmentQuestionnaire: "investmentQuestionnaire",
	portfolio: "portfolio",
} as const;

export const useGetIconByType = (type: NotificationTypeEnum, color: string) => {
	const { iconSize } = useTheme();

	switch (type) {
		case NotificationTypeEnum.MeetingRecord:
			return {
				icon: <FileText size={iconSize.sm} color={color} />,
				type: NotificationType.meetingRecord,
			};
		case NotificationTypeEnum.DocumentExpires:
		case NotificationTypeEnum.SetAdvisor:
		case NotificationTypeEnum.TaskShared:
		case NotificationTypeEnum.TaskEditTerm:
		case NotificationTypeEnum.TaskEditDescription:
		case NotificationTypeEnum.TaskAddWorkflow:
		case NotificationTypeEnum.TaskEditWorkflow:
		case NotificationTypeEnum.TaskDeleteWorkflow:
		case NotificationTypeEnum.TaskAddWorkflowItem:
		case NotificationTypeEnum.TaskEditWorkflowItem:
		case NotificationTypeEnum.TaskDeleteWorkflowItem:
		case NotificationTypeEnum.TaskResolveWorkflotItem:
		case NotificationTypeEnum.TaskTerm:
		case NotificationTypeEnum.TaskTermNotice:
		case NotificationTypeEnum.TaskGroup:
			return {
				icon: <SquareCheckBig size={iconSize.sm} color={color} />,
				type: NotificationType.task,
			};
		case NotificationTypeEnum.InvestmentQuestionnaire:
			return {
				icon: <FileText size={iconSize.sm} color={color} />,
				type: NotificationType.investmentQuestionnaire,
			};
		case NotificationTypeEnum.PortfolioEnd:
		case NotificationTypeEnum.PortfolioAnniversary:
		case NotificationTypeEnum.PortfolioFixationEnd:
			return {
				icon: <Shield size={iconSize.sm} color={color} />,
				type: NotificationType.portfolio,
			};
		default:
			return {
				icon: (
					<MyplannActivityIcon
						width={iconSize.sm}
						height={iconSize.sm}
						color={color}
					/>
				),
				type: NotificationType.activity,
			};
	}
};
